/* GBN product cards: keep the price in sync with the picked option. Loaded once per page. */
(function () {
  if (window.__gbnCards) return; window.__gbnCards = true;
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('[data-gbn-variant-select]')) return;
    var o = sel.options[sel.selectedIndex], box = sel.closest('.gbn-card-buy');
    if (!o || !box) return;
    var p = box.querySelector('[data-gbn-price]'); if (p) p.textContent = o.getAttribute('data-price');
    var c = box.querySelector('[data-gbn-compare]');
    if (c) { var cv = o.getAttribute('data-compare'); c.textContent = cv || ''; c.hidden = !cv; }
  });
})();
